/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@jira/software__capacity/src/__generated__/HeaderControlPanelContentQuery$parameters.ts';
import type { HeaderControlPanelContentQuery } from '@jira/software__capacity/src/__generated__/HeaderControlPanelContentQuery.graphql.ts';
import type { SoftwareCapacityHeaderControlPanelEntryPointEntrypointProps } from './SoftwareCapacityHeaderControlPanelEntryPoint.entrypoint.types.tsx';

type HeaderControlPanelQueries = {
	headerControlPanelData: HeaderControlPanelContentQuery;
};

type CapacityHeaderControlPanelEntryPointComponent = EntryPointComponent<
	HeaderControlPanelQueries,
	{},
	SoftwareCapacityHeaderControlPanelEntryPointEntrypointProps,
	{}
>;

export const capacityHeaderControlPanelEntryPoint: EntryPoint<
	CapacityHeaderControlPanelEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CapacityHeaderControlPanelEntryPointComponent>(
		/* webpackChunkName: "async-jira-capacity-header-control-panel" */ './SoftwareCapacityHeaderControlPanelEntryPoint.tsx',
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const {
			context: { match },
			tenantContext,
		} = entryPointRouteParams;

		const boardId = match.params.boardId;
		if (!boardId) {
			throw new Error('boardId is required for capacity header control panel');
		}

		const sourceAri = `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}`;

		return {
			queries: {
				headerControlPanelData: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						id: sourceAri,
					},
				},
			},
		};
	},
});
